import Banner from "ds/components/Banner";
import Box from "ds/components/Box";
import FormField from "ds/components/Form/Field";
import Select from "ds/components/Select";
import tooltips from "shared/Scan/tooltips";

type IntegrationOption = {
  id: string;
  name: string;
  generateCredentialsInWorker: boolean;
};

type IntegrationFieldProps = {
  value: string;
  onChange: (value: string) => void;
  options: IntegrationOption[];
  isLoading?: boolean;
  error?: string;
  helperText?: string;
  noMargin?: boolean;
};

const IntegrationField = ({
  value,
  onChange,
  options,
  isLoading,
  error,
  helperText,
  noMargin,
}: IntegrationFieldProps) => {
  const items = options.map(({ id, name }) => ({ value: id, label: name }));
  const selectedIntegration = options.find((integration) => integration.id === value);

  return (
    <Box direction="column" gap="medium" margin={noMargin ? undefined : "x-large 0 0"}>
      <FormField
        label="Integration"
        tooltipInfo={tooltips.INTEGRATION}
        tooltipInfoVariant="modal"
        error={error}
        helperText={helperText}
        noMargin
      >
        {({ ariaInputProps }) => (
          <Select
            value={value}
            items={items}
            isLoading={isLoading}
            onChange={onChange}
            placeholder="Please select"
            isError={!!error}
            {...ariaInputProps}
          />
        )}
      </FormField>

      {selectedIntegration && !selectedIntegration.generateCredentialsInWorker && (
        <Banner variant="warning">
          This integration doesn't have Assume role on worker enabled, so the scan's credentials are
          limited to a 1-hour session. Enable it on the integration to allow sessions of up to 12
          hours.
        </Banner>
      )}
    </Box>
  );
};

export default IntegrationField;
